import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  variants: [],
  template: {},
  furtherOffers: [],
  staticStorage: {},
  notFound: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};